import React, { useState } from 'react'

import {
  Box,
  Button,
  Flex,
  Heading,
  PasswordTextField,
  Text,
} from 'components/ds'

import { useTranslation } from '@disco/i18n/use-translation'

type Props = {
  invalidPassword: boolean
  onSubmit: (password: string) => void
}

const PlaylistPasswordForm = ({
  invalidPassword,
  onSubmit,
}: Props): React.ReactNode => {
  const { t } = useTranslation('shares')
  const [password, setPassword] = useState('')

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    if (!password) return
    onSubmit(password)
  }

  return (
    <Box width="312px">
      <form onSubmit={handleSubmit}>
        <Flex direction="column" gap="4">
          <Heading size="6" m="0">
            {t(
              'shares:thisPlaylistIsPasswordProtected',
              'This playlist is password protected',
            )}
          </Heading>
          <Text size="2" color="gray">
            {t(
              'shares:enterPlaylistPasswordToSave',
              'Enter the playlist password to save it to your DISCO.',
            )}
          </Text>
          <Flex direction="column" gap="1">
            <PasswordTextField
              size="3"
              autoFocus
              autoComplete="off"
              aria-label={t('shares:inputPassword', 'Input password')}
              placeholder={t('shares:inputPassword', 'Input password')}
              value={password}
              color={invalidPassword ? 'red' : undefined}
              onChange={event => setPassword(event.target.value)}
              data-testid="add-to-disco-playlist-password-input"
            />
            {invalidPassword && (
              <Text size="2" color="red" role="alert">
                {t(
                  'shares:sorryThatPasswordIsIncorrect',
                  'Sorry, that password is incorrect',
                )}
              </Text>
            )}
          </Flex>
          <Button
            type="submit"
            size="3"
            highContrast
            disabled={!password}
            data-testid="add-to-disco-playlist-password-submit"
          >
            {t('shares:saveToDisco', 'Save to DISCO')}
          </Button>
        </Flex>
      </form>
    </Box>
  )
}

export default PlaylistPasswordForm
